// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/completion_page_v1.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes flyin-bottom {
    0% {
        transform: translateY(50%);
        opacity: 0;
    }
    100% {
        transform: translateY(0%);
        opacity: 1;
    }
}

@keyframes background-fadein {
    0% {
        filter: brightness(0);
    }
    100% {
        filter: brightness(1);
    }
}

.completion-page-content {
    display: grid;
    grid-template-columns: 1fr 1fr;
    align-items: center;
    justify-content: center;
    gap: 20px;
    min-height: 100vh;
    box-sizing: border-box;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-size: cover;
    background-position: bottom;
    animation: background-fadein 0.8s ease-in-out;
    overflow: hidden;
}
.cpc-pane1 {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-end;
    padding: 30px 10px;
    box-sizing: border-box;
    color: #fff;
    height: 100%;
}
.cpc-pane2 {
    margin: auto 0;
    display: flex;
    align-items: center;
    justify-content: left;
    padding: 20px 10px;
    box-sizing: border-box;
    animation: flyin-bottom 0.2s ease-out;
    animation-delay: 1.1s;
    animation-fill-mode: both;
    height: 100%;
}
@media screen and (max-width: 1700px) {
    .completion-page-content {
        display: flex !important;
        flex-direction: column !important;
        gap: 0;
        padding: 20px 0;
    }
    .cpc-pane1 {
        margin: 0;
        padding: 20px;
        box-sizing: border-box;
        width: 100%;
        height: auto;
        color: #fff;
    }
    .cpc-pane2 {
        margin: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 20px;
        box-sizing: border-box;
        width: 100%;
        height: auto;
        background-image: linear-gradient(90deg, #0002 15%, #0008 50%, #0002 85%);
    }
    .completion-title {
        padding: 0 min(3%, 40px) !important;
        text-align: center !important;
    }
    .completion-subtitle {
        padding: 0 min(3%, 40px) !important;
        text-align: center !important;
    }
    .completion-text {
        padding: 0 min(3%, 40px) !important;
        text-align: center !important;
    }

    .cpc-pane1 {
        padding: 15px;
    }
    .cpc-pane2 {
        padding: 15px;
    }

    .completion-body-container {
        margin: 20px auto 0 auto !important;
        border-top-right-radius: 20px;
        border-bottom-right-radius: 20px;
    }
    .completion-header-container {
        background-color: transparent !important;
        padding: 0 !important;
        border-top-left-radius: 0 !important;
        border-bottom-left-radius: 0 !important;
        max-width: unset !important;
    }
}

@media screen and (max-width: 600px) {
    .social-media-share-button {
        width: 28px;
        height: 28px;
    }
    .completion-body-container {
        padding: 10px 20px;
    }
    .completion-title {
        font-size: 60px !important;
        padding: 0 !important;
    }
    .completion-subtitle {
        font-size: 30px !important;
        padding: 0 !important;
    }
    .completion-text {
        font-size: 18px !important;
        padding: 0 !important;
    }
    .completion-body-container {
        margin: 20px auto 0 auto !important;
        padding: 20px 15px !important;
    }
}

.completion-header-container {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    margin: 0;
    padding: 20px;
    box-sizing: border-box;
    width: 100%;
    max-width: 850px;
    word-wrap: break-word;
    border-top-left-radius: 20px;
    border-bottom-left-radius: 20px;
    background-color: #000a;
    animation: flyin-bottom 0.3s ease-out;
    animation-delay: 0.8s;
    animation-fill-mode: both;
    /* Same animation as title */
}
.completion-title {
    margin: 0;
    padding: 0;
    width: 100%;
    text-align: center;
    font-family: var(--displayFont);
    font-size: 100px;
    text-align: right;
    box-sizing: border-box;
    animation: flyin-bottom 0.3s ease-out;
    animation-delay: 0.8s;
    animation-fill-mode: both;
}
.completion-subtitle {
    margin: 0;
    padding: 0;
    width: 100%;
    text-align: right;
    font-family: var(--displayFont);
    font-size: 50px;
    box-sizing: border-box;
    animation: flyin-bottom 0.3s ease;
    animation-delay: 0.9s;
    animation-fill-mode: both;
}
.completion-text {
    margin: 10px auto;
    padding: 0;
    text-align: right;
    font-family: var(--paragraphFont);
    font-size: 20px;
    font-weight: 500;
    box-sizing: border-box;
    animation: flyin-bottom 0.3s ease;
    animation-delay: 1s;
    animation-fill-mode: both;
}

.completion-body-container {
    display: flex;
    flex-wrap: wrap;
    gap: 20px 50px;
    justify-content: center;
    font-family: var(--paragraphFont);
    font-size: 20px;
    font-weight: 400;
    box-sizing: border-box;
    margin: 50px 0 0 auto;
    padding: 40px 30px;
    width: -moz-fit-content;
    width: fit-content;
    max-width: 100%;
    background-color: #000a;
    border-top-left-radius: 20px;
    border-bottom-left-radius: 20px;
    box-shadow: -1px 1px 16px #0004;
    animation: flyin-bottom 0.4s ease;
    animation-delay: 1.1s;
    animation-fill-mode: both;
}

.completion-minilabel {
    margin: 0 0 10px 0;
    padding: 0;
    width: 100%;
    text-align: center;
    font-family: var(--displayFont);
    font-size: 14px;
    font-weight: 500;
    box-sizing: border-box;
    animation: flyin-bottom 0.4s ease;
    animation-delay: 1.2s;
    animation-fill-mode: both;
}

.next-steps-container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 20px;
    text-align: center;
    font-size: 18px;
    box-sizing: border-box;
}

.share-container {
    display: flex;
    flex-direction: column;
    max-width: 100%;
    box-sizing: border-box;
    text-align: center;
    font-family: var(--paragraphFont);
    font-size: 20px;
    font-weight: 500;
    box-sizing: border-box;
    max-width: 400px;
    overflow: hidden;
    gap: 20px;
    padding: 10px 0;
}
.social-media-icons-container {
    height: -moz-fit-content;
    height: fit-content;
    display: flex;
    justify-content: space-evenly;
    align-items: center;
}
.share-link-container {
    height: -moz-fit-content;
    height: fit-content;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 20px;
    text-align: center;
    font-family: var(--paragraphFont);
    font-size: 20px;
    font-weight: 400;
    max-width: 100%;
    box-sizing: border-box;
}

.share-link-input {
    border-radius: 1000px;
    font-family: var(--paragraphFont);
    font-size: 20px;
    font-weight: 400;
    padding: 10px 20px;
    width: 100%;
    height: -moz-fit-content;
    height: fit-content;
    background-color: white;
    text-decoration: none;
    transition: all 0.3s ease 0s;
    cursor: pointer;
    border: none;
}

.social-media-share-button {
    border: none;
    cursor: pointer;
    transition: 0.2s ease;
    width: 36px;
    height: 36px;
    padding: 0;
    position: relative;
    background-color: transparent;
}
.social-media-share-button:hover {
    transform: scale(1.1);
}
.social-media-share-icon {
    width: 100%;
    height: 100%;
}`, "",{"version":3,"sources":["webpack://./src/styles/completion/CompletionPage.css"],"names":[],"mappings":"AAAA;IACI;QACI,0BAA0B;QAC1B,UAAU;IACd;IACA;QACI,yBAAyB;QACzB,UAAU;IACd;AACJ;;AAEA;IACI;QACI,qBAAqB;IACzB;IACA;QACI,qBAAqB;IACzB;AACJ;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,uBAAuB;IACvB,SAAS;IACT,iBAAiB;IACjB,sBAAsB;IACtB,yDAA4D;IAC5D,sBAAsB;IACtB,2BAA2B;IAC3B,6CAA6C;IAC7C,gBAAgB;AACpB;AACA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,qBAAqB;IACrB,kBAAkB;IAClB,sBAAsB;IACtB,WAAW;IACX,YAAY;AAChB;AACA;IACI,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,qBAAqB;IACrB,kBAAkB;IAClB,sBAAsB;IACtB,qCAAqC;IACrC,qBAAqB;IACrB,yBAAyB;IACzB,YAAY;AAChB;AACA;IACI;QACI,wBAAwB;QACxB,iCAAiC;QACjC,MAAM;QACN,eAAe;IACnB;IACA;QACI,SAAS;QACT,aAAa;QACb,sBAAsB;QACtB,WAAW;QACX,YAAY;QACZ,WAAW;IACf;IACA;QACI,SAAS;QACT,aAAa;QACb,mBAAmB;QACnB,uBAAuB;QACvB,aAAa;QACb,sBAAsB;QACtB,WAAW;QACX,YAAY;QACZ,yEAAyE;IAC7E;IACA;QACI,mCAAmC;QACnC,6BAA6B;IACjC;IACA;QACI,mCAAmC;QACnC,6BAA6B;IACjC;IACA;QACI,mCAAmC;QACnC,6BAA6B;IACjC;;IAEA;QACI,aAAa;IACjB;IACA;QACI,aAAa;IACjB;;IAEA;QACI,mCAAmC;QACnC,6BAA6B;QAC7B,gCAAgC;IACpC;IACA;QACI,wCAAwC;QACxC,qBAAqB;QACrB,oCAAoC;QACpC,uCAAuC;QACvC,2BAA2B;IAC/B;AACJ;;AAEA;IACI;QACI,WAAW;QACX,YAAY;IAChB;IACA;QACI,kBAAkB;IACtB;IACA;QACI,0BAA0B;QAC1B,qBAAqB;IACzB;IACA;QACI,0BAA0B;QAC1B,qBAAqB;IACzB;IACA;QACI,0BAA0B;QAC1B,qBAAqB;IACzB;IACA;QACI,mCAAmC;QACnC,6BAA6B;IACjC;AACJ;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,qBAAqB;IACrB,SAAS;IACT,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,gBAAgB;IAChB,qBAAqB;IACrB,4BAA4B;IAC5B,+BAA+B;IAC/B,uBAAuB;IACvB,qCAAqC;IACrC,qBAAqB;IACrB,yBAAyB;IACzB,4BAA4B;AAChC;AACA;IACI,SAAS;IACT,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,+BAA+B;IAC/B,gBAAgB;IAChB,iBAAiB;IACjB,sBAAsB;IACtB,qCAAqC;IACrC,qBAAqB;IACrB,yBAAyB;AAC7B;AACA;IACI,SAAS;IACT,UAAU;IACV,WAAW;IACX,iBAAiB;IACjB,+BAA+B;IAC/B,eAAe;IACf,sBAAsB;IACtB,iCAAiC;IACjC,qBAAqB;IACrB,yBAAyB;AAC7B;AACA;IACI,iBAAiB;IACjB,UAAU;IACV,iBAAiB;IACjB,iCAAiC;IACjC,eAAe;IACf,gBAAgB;IAChB,sBAAsB;IACtB,iCAAiC;IACjC,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,eAAe;IACf,cAAc;IACd,uBAAuB;IACvB,iCAAiC;IACjC,eAAe;IACf,gBAAgB;IAChB,sBAAsB;IACtB,qBAAqB;IACrB,kBAAkB;IAClB,uBAAkB;IAAlB,kBAAkB;IAClB,eAAe;IACf,uBAAuB;IACvB,4BAA4B;IAC5B,+BAA+B;IAC/B,+BAA+B;IAC/B,iCAAiC;IACjC,qBAAqB;IACrB,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,+BAA+B;IAC/B,eAAe;IACf,gBAAgB;IAChB,sBAAsB;IACtB,iCAAiC;IACjC,qBAAqB;IACrB,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;IACT,kBAAkB;IAClB,eAAe;IACf,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,eAAe;IACf,sBAAsB;IACtB,kBAAkB;IAClB,iCAAiC;IACjC,eAAe;IACf,gBAAgB;IAChB,sBAAsB;IACtB,gBAAgB;IAChB,gBAAgB;IAChB,SAAS;IACT,eAAe;AACnB;AACA;IACI,wBAAmB;IAAnB,mBAAmB;IACnB,aAAa;IACb,6BAA6B;IAC7B,mBAAmB;AACvB;AACA;IACI,wBAAmB;IAAnB,mBAAmB;IACnB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,SAAS;IACT,kBAAkB;IAClB,iCAAiC;IACjC,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,sBAAsB;AAC1B;;AAEA;IACI,qBAAqB;IACrB,iCAAiC;IACjC,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,WAAW;IACX,wBAAmB;IAAnB,mBAAmB;IACnB,uBAAuB;IACvB,qBAAqB;IACrB,4BAA4B;IAC5B,eAAe;IACf,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,eAAe;IACf,qBAAqB;IACrB,WAAW;IACX,YAAY;IACZ,UAAU;IACV,kBAAkB;IAClB,6BAA6B;AACjC;AACA;IACI,qBAAqB;AACzB;AACA;IACI,WAAW;IACX,YAAY;AAChB","sourcesContent":["@keyframes flyin-bottom {\n    0% {\n        transform: translateY(50%);\n        opacity: 0;\n    }\n    100% {\n        transform: translateY(0%);\n        opacity: 1;\n    }\n}\n\n@keyframes background-fadein {\n    0% {\n        filter: brightness(0);\n    }\n    100% {\n        filter: brightness(1);\n    }\n}\n\n.completion-page-content {\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    align-items: center;\n    justify-content: center;\n    gap: 20px;\n    min-height: 100vh;\n    box-sizing: border-box;\n    background-image: url('../../assets/completion_page_v1.png');\n    background-size: cover;\n    background-position: bottom;\n    animation: background-fadein 0.8s ease-in-out;\n    overflow: hidden;\n}\n.cpc-pane1 {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: flex-end;\n    padding: 30px 10px;\n    box-sizing: border-box;\n    color: #fff;\n    height: 100%;\n}\n.cpc-pane2 {\n    margin: auto 0;\n    display: flex;\n    align-items: center;\n    justify-content: left;\n    padding: 20px 10px;\n    box-sizing: border-box;\n    animation: flyin-bottom 0.2s ease-out;\n    animation-delay: 1.1s;\n    animation-fill-mode: both;\n    height: 100%;\n}\n@media screen and (max-width: 1700px) {\n    .completion-page-content {\n        display: flex !important;\n        flex-direction: column !important;\n        gap: 0;\n        padding: 20px 0;\n    }\n    .cpc-pane1 {\n        margin: 0;\n        padding: 20px;\n        box-sizing: border-box;\n        width: 100%;\n        height: auto;\n        color: #fff;\n    }\n    .cpc-pane2 {\n        margin: 0;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        padding: 20px;\n        box-sizing: border-box;\n        width: 100%;\n        height: auto;\n        background-image: linear-gradient(90deg, #0002 15%, #0008 50%, #0002 85%);\n    }\n    .completion-title {\n        padding: 0 min(3%, 40px) !important;\n        text-align: center !important;\n    }\n    .completion-subtitle {\n        padding: 0 min(3%, 40px) !important;\n        text-align: center !important;\n    }\n    .completion-text {\n        padding: 0 min(3%, 40px) !important;\n        text-align: center !important;\n    }\n\n    .cpc-pane1 {\n        padding: 15px;\n    }\n    .cpc-pane2 {\n        padding: 15px;\n    }\n\n    .completion-body-container {\n        margin: 20px auto 0 auto !important;\n        border-top-right-radius: 20px;\n        border-bottom-right-radius: 20px;\n    }\n    .completion-header-container {\n        background-color: transparent !important;\n        padding: 0 !important;\n        border-top-left-radius: 0 !important;\n        border-bottom-left-radius: 0 !important;\n        max-width: unset !important;\n    }\n}\n\n@media screen and (max-width: 600px) {\n    .social-media-share-button {\n        width: 28px;\n        height: 28px;\n    }\n    .completion-body-container {\n        padding: 10px 20px;\n    }\n    .completion-title {\n        font-size: 60px !important;\n        padding: 0 !important;\n    }\n    .completion-subtitle {\n        font-size: 30px !important;\n        padding: 0 !important;\n    }\n    .completion-text {\n        font-size: 18px !important;\n        padding: 0 !important;\n    }\n    .completion-body-container {\n        margin: 20px auto 0 auto !important;\n        padding: 20px 15px !important;\n    }\n}\n\n.completion-header-container {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-end;\n    margin: 0;\n    padding: 20px;\n    box-sizing: border-box;\n    width: 100%;\n    max-width: 850px;\n    word-wrap: break-word;\n    border-top-left-radius: 20px;\n    border-bottom-left-radius: 20px;\n    background-color: #000a;\n    animation: flyin-bottom 0.3s ease-out;\n    animation-delay: 0.8s;\n    animation-fill-mode: both;\n    /* Same animation as title */\n}\n.completion-title {\n    margin: 0;\n    padding: 0;\n    width: 100%;\n    text-align: center;\n    font-family: var(--displayFont);\n    font-size: 100px;\n    text-align: right;\n    box-sizing: border-box;\n    animation: flyin-bottom 0.3s ease-out;\n    animation-delay: 0.8s;\n    animation-fill-mode: both;\n}\n.completion-subtitle {\n    margin: 0;\n    padding: 0;\n    width: 100%;\n    text-align: right;\n    font-family: var(--displayFont);\n    font-size: 50px;\n    box-sizing: border-box;\n    animation: flyin-bottom 0.3s ease;\n    animation-delay: 0.9s;\n    animation-fill-mode: both;\n}\n.completion-text {\n    margin: 10px auto;\n    padding: 0;\n    text-align: right;\n    font-family: var(--paragraphFont);\n    font-size: 20px;\n    font-weight: 500;\n    box-sizing: border-box;\n    animation: flyin-bottom 0.3s ease;\n    animation-delay: 1s;\n    animation-fill-mode: both;\n}\n\n.completion-body-container {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 20px 50px;\n    justify-content: center;\n    font-family: var(--paragraphFont);\n    font-size: 20px;\n    font-weight: 400;\n    box-sizing: border-box;\n    margin: 50px 0 0 auto;\n    padding: 40px 30px;\n    width: fit-content;\n    max-width: 100%;\n    background-color: #000a;\n    border-top-left-radius: 20px;\n    border-bottom-left-radius: 20px;\n    box-shadow: -1px 1px 16px #0004;\n    animation: flyin-bottom 0.4s ease;\n    animation-delay: 1.1s;\n    animation-fill-mode: both;\n}\n\n.completion-minilabel {\n    margin: 0 0 10px 0;\n    padding: 0;\n    width: 100%;\n    text-align: center;\n    font-family: var(--displayFont);\n    font-size: 14px;\n    font-weight: 500;\n    box-sizing: border-box;\n    animation: flyin-bottom 0.4s ease;\n    animation-delay: 1.2s;\n    animation-fill-mode: both;\n}\n\n.next-steps-container {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    gap: 20px;\n    text-align: center;\n    font-size: 18px;\n    box-sizing: border-box;\n}\n\n.share-container {\n    display: flex;\n    flex-direction: column;\n    max-width: 100%;\n    box-sizing: border-box;\n    text-align: center;\n    font-family: var(--paragraphFont);\n    font-size: 20px;\n    font-weight: 500;\n    box-sizing: border-box;\n    max-width: 400px;\n    overflow: hidden;\n    gap: 20px;\n    padding: 10px 0;\n}\n.social-media-icons-container {\n    height: fit-content;\n    display: flex;\n    justify-content: space-evenly;\n    align-items: center;\n}\n.share-link-container {\n    height: fit-content;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    gap: 20px;\n    text-align: center;\n    font-family: var(--paragraphFont);\n    font-size: 20px;\n    font-weight: 400;\n    max-width: 100%;\n    box-sizing: border-box;\n}\n\n.share-link-input {\n    border-radius: 1000px;\n    font-family: var(--paragraphFont);\n    font-size: 20px;\n    font-weight: 400;\n    padding: 10px 20px;\n    width: 100%;\n    height: fit-content;\n    background-color: white;\n    text-decoration: none;\n    transition: all 0.3s ease 0s;\n    cursor: pointer;\n    border: none;\n}\n\n.social-media-share-button {\n    border: none;\n    cursor: pointer;\n    transition: 0.2s ease;\n    width: 36px;\n    height: 36px;\n    padding: 0;\n    position: relative;\n    background-color: transparent;\n}\n.social-media-share-button:hover {\n    transform: scale(1.1);\n}\n.social-media-share-icon {\n    width: 100%;\n    height: 100%;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
